import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-select-usuario',
  templateUrl: './select-usuario.component.html',
  styleUrls: ['./select-usuario.component.css']
})
export class SelectUsuarioComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
